import { iframeResize } from 'iframe-resizer'

for (let agenda of document.querySelectorAll('.agenda')) {
  agenda.onload = () => {
    iframeResize({}, agenda)
  }
}
